export const environment = {
  BASE_API_PATH: "https://api.flow2k.ca/api/", // Using VM API same as production
  BASE_IMAGE_PATH: '',
  firebaseConfig: {
    apiKey: "AIzaSyCV1wN8WtNQEsW0XRDdGSkBjOsyYorZLe4",
    authDomain: "flow2k-356b6.firebaseapp.com",
    projectId: "flow2k-356b6",
    storageBucket: "flow2k-356b6.appspot.com",
    messagingSenderId: "746764751928",
    appId: "1:746764751928:web:34f426f6c71211053142cd",
    measurementId: "G-2PGHDRMP5C"
  },
  production: false, // Staging environment
  stripe_public_key: "pk_test_51OgrUuDyxYASvFe3SM2xqLH5iyk9B0LfPtRGQrCIkAJ2lLmN58X6futZ1Ut9gYu5cxmeGydp5N5hTN7ZNeIAG2tn00DeruC2Eu",
  
  // Staging-specific configurations
  enableAnalytics: false,
  enableDebugMode: true,
  enableServiceWorker: false
};
